import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DashboardHeaderComponent } from '../structure/header/header';
import { DashboardSidebarComponent } from '../structure/sidebar/sidebar';
import { DEFAULT_DASHBOARD_USER } from '../dashboard/dashboard.data';

type PanelMode = 'chats' | 'users';

@Component({
  selector: 'app-workplace-chat',
  standalone: true,
  imports: [
    CommonModule,
    DashboardHeaderComponent,
    DashboardSidebarComponent,
  ],
  templateUrl: './workplace-chat.html',
  styleUrl: './workplace-chat.scss',
})
export class WorkplaceChatPage implements OnInit {
  protected readonly user = DEFAULT_DASHBOARD_USER;

  protected sidebarCollapsed = false;
  protected mobileSidebarOpen = false;
  protected leftPanelMode: PanelMode = 'chats';
  protected setupMessage = 'Workplace Chat is ready for the local backend chat integration.';

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      this.setupMessage = 'Workplace Chat is available in the browser only.';
    }
  }

  protected handleMenuToggle(): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 1024) {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      return;
    }

    this.mobileSidebarOpen = !this.mobileSidebarOpen;
  }

  protected closeMobileSidebar(): void {
    this.mobileSidebarOpen = false;
  }

  protected toggleLeftPanelMode(): void {
    this.leftPanelMode = this.leftPanelMode === 'chats' ? 'users' : 'chats';
  }
}
